/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GiustificativiUploadAllegatiDTO
 */
export interface GiustificativiUploadAllegatiDTO {
    /**
     * 
     * @type {number}
     * @memberof GiustificativiUploadAllegatiDTO
     */
    idLavoro?: number;
    /**
     * 
     * @type {number}
     * @memberof GiustificativiUploadAllegatiDTO
     */
    idTipoRimborso?: number;
}

/**
 * Check if a given object implements the GiustificativiUploadAllegatiDTO interface.
 */
export function instanceOfGiustificativiUploadAllegatiDTO(value: object): value is GiustificativiUploadAllegatiDTO {
    return true;
}

export function GiustificativiUploadAllegatiDTOFromJSON(json: any): GiustificativiUploadAllegatiDTO {
    return GiustificativiUploadAllegatiDTOFromJSONTyped(json, false);
}

export function GiustificativiUploadAllegatiDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): GiustificativiUploadAllegatiDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idLavoro': json['idLavoro'] == null ? undefined : json['idLavoro'],
        'idTipoRimborso': json['idTipoRimborso'] == null ? undefined : json['idTipoRimborso'],
    };
}

export function GiustificativiUploadAllegatiDTOToJSON(json: any): GiustificativiUploadAllegatiDTO {
    return GiustificativiUploadAllegatiDTOToJSONTyped(json, false);
}

export function GiustificativiUploadAllegatiDTOToJSONTyped(value?: GiustificativiUploadAllegatiDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idLavoro': value['idLavoro'],
        'idTipoRimborso': value['idTipoRimborso'],
    };
}

